import React from "react";
import useByggherreAccess from "@/hooks/useByggherreAccess";
import { Building2 } from "lucide-react";
import SectionDocumentEditor from "./SectionDocumentEditor";
import {
  BYGGHERRE_HANDLING_SECTIONS,
  BYGGHERRE_STATUS_LABELS,
} from "@/lib/basProcess/byggherreDocs";
import { generateByggherreHandlingWordDocument } from "@/lib/documentGenerator/byggherreWordGenerators";

export const ByggherreHandling: React.FC<{ projectId: string }> = ({ projectId }) => {
  const { canManage } = useByggherreAccess(projectId);
  return (
  <SectionDocumentEditor
    projectId={projectId}
    table="byggherre_documents"
    docNumber="50"
    documentType="byggherre_hantering"
    title="Byggherrens hantering av byggarbetsmiljöarbete"
    description="Byggherrens överordnade dokument: organisation, kompetens, hur Bas-P och Bas-U utses och följs upp, samt hur tillsyn och kontroll utövas genom hela projektet."
    legalRef="AML 3 kap. 6 § · AFS 2023:3 2 kap. 9–12, 15–19, 23–24 §§"
    icon={Building2}
    sections={BYGGHERRE_HANDLING_SECTIONS}
    statusLabels={BYGGHERRE_STATUS_LABELS}
    defaultName="Byggherrens hantering av byggarbetsmiljöarbete"
    onExport={(doc, projectName) => generateByggherreHandlingWordDocument(doc, projectName)}
    emptyText="Inget byggherredokument upprättat ännu. Skapa det med förifylld standardtext och anpassa efter er organisation."
  readOnly={!canManage}
    auditDocumentType="byggherre_hantering"
  />
  );
};

export default ByggherreHandling;
